import { APIError } from 'models/errors';

export type Registration = {
  id: string;
  type: string;
  attributes: {
    timestamp: string;
    iprId: string;
    startTime: number;
    endTime: number;
    duration: number;
  };
};

export type Log = {
  id: string;
  type: string;
  attributes: {
    timestamp: string;
    severity: string;
    class: string;
    message: string;
  };
};

export interface Lwm2mResponse {
  data: Registration[];
  errors?: APIError[];
}

export type Lwm2mFilter = {
  attribute: Lwm2mFilterAttribute;
  value: string;
};
export enum Lwm2mFilterAttribute {
  IprId = 'iprId',
}
export type Lwm2mSuccess = {
  response: Registration[];
  totalCount: number;
  filters: Lwm2mFilter[] | null;
};

export type Lwm2mDetailsSuccess = {
  logs: Log[];
};

export type Lwm2mState = {
  list: Lwm2mList;
  details: Lwm2mDetails;
};

export type Lwm2mList = {
  data: Registration[] | null;
  totalCount: number;
  isLoading: boolean;
  error: APIError | null;
  filters: {
    active: boolean;
    data: Lwm2mFilter[] | null;
  };
};

export type Lwm2mDetails = {
  logs: Log[] | null;
  isLoading: boolean;
  error: APIError | null;
};
